import React from "react";

const AcceptableUsePolicy = () => {
  return (
    <div className="w-3/4 bg-[#04152d] p-4 text-white leading-8">
      <h2 className="text-[32px] font-bold mb-4">
        POLITIQUE D'UTILISATION ACCEPTABLE
      </h2>
      <br></br>
      <h3 className="font-semibold text-xl">Introduction </h3>
      <br></br>
      Les présentes conditions générales s'appliquent entre vous, l'utilisateur
      de ce site Web (y compris les sous-domaines, sauf exclusion expresse par
      leurs propres conditions générales), et Vivalimda Ltd, le propriétaire et
      l'exploitant de ce site Web. Veuillez lire attentivement ces termes et
      conditions, car ils affectent vos droits légaux. Votre consentement à vous
      conformer et à être lié par les présentes conditions générales est réputé
      avoir eu lieu lors de votre première utilisation du site Web. Si vous
      n'acceptez pas d'être lié par ces conditions générales, vous devez cesser
      immédiatement d'utiliser le site Web. Dans les présentes conditions
      générales, l'utilisateur ou les utilisateurs désignent tout tiers qui
      accède au site Web et qui n'est pas (i) employé par Vivalimda Ltd et
      agissant dans le cadre de son emploi ou (ii) engagé en tant que consultant
      ou fournissant autrement des services à Vivalimda Ltd et accédant au site
      Web dans le cadre de la fourniture de ces services. Vous devez être âgé
      d'au moins 18 ans pour utiliser ce site Web. En utilisant le site Web et
      en acceptant les présentes conditions générales, vous déclarez et
      garantissez que vous êtes âgé d'au moins 18 ans.
      <br /> <br></br>
      <h3 className="font-semibold text-xl">Utilisation acceptable </h3>
      <br></br>
      1. Tout le contenu inclus sur le site Web, à moins qu'il ne soit
      téléchargé par les utilisateurs, est la propriété de Vivalimda Ltd, de nos
      sociétés affiliées ou d'autres tiers concernés. Dans les présentes
      conditions générales, le contenu désigne tout texte, graphique, image,
      audio, vidéo, logiciel, compilation de données, mise en page, code et
      logiciel sous-jacents et toute autre forme d'information susceptible
      d'être stockée dans un ordinateur qui apparaît sur ce site Web ou qui en
      fait partie, y compris tout contenu téléchargé par les utilisateurs. En
      continuant à utiliser le site Web, vous reconnaissez que ce contenu est
      protégé par le droit d'auteur, les marques de commerce, les droits sur les
      bases de données et d'autres droits de propriété intellectuelle. Rien sur
      ce site ne doit être interprété comme accordant, par implication,
      préclusion ou autrement, une licence ou un droit d'utilisation d'une
      marque de commerce, d'un logo ou d'une marque de service affichée sur le
      site sans l'autorisation écrite préalable du propriétaire.
      <br></br>
      2. Vous pouvez, pour votre usage personnel et non commercial uniquement,
      faire ce qui suit :a. récupérer, afficher et visualiser le contenu sur un
      appareilb. imprimer une copie du contenu
      <br></br>
      3. Vous ne devez pas reproduire, modifier, copier, distribuer ou utiliser
      à des fins commerciales tout contenu sans l'autorisation écrite de
      Vivalimda Ltd.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Utilisation interdite </h3>
      <br></br>
      4. Vous ne pouvez pas utiliser le site Web à l'une des fins suivantes :a.
      d'une manière qui cause, ou pourrait causer, des dommages au site Web ou
      interfère avec l'utilisation ou la jouissance du site Web par toute autre
      personne ;b. d'une manière nuisible, illégale, illégale, abusive,
      harcelante, menaçante ou autrement répréhensible ou en violation de toute
      loi applicable, réglementation, ordonnance gouvernementale ;c. faire,
      transmettre ou stocker des copies électroniques de contenu protégé par le
      droit d'auteur sans l'autorisation du propriétaire.
      <br></br>
      <h3 className="font-semibold text-xl">Inscription </h3>
      5. Vous devez vous assurer que les données que vous avez fournies lors de
      votre inscription ou à tout moment sont correctes et complètes.
      <br></br>
      6. Vous devez nous informer immédiatement de toute modification des
      informations que vous fournissez lors de votre inscription en mettant à
      jour vos données personnelles afin que nous puissions communiquer
      efficacement avec vous.
      <br></br>
      7. Nous pouvons suspendre ou annuler votre inscription avec effet immédiat
      à des fins raisonnables ou si vous ne respectez pas les présentes
      conditions générales.
      <br></br>
      8. pouvez annuler votre inscription à tout moment en nous en informant par
      écrit à l'adresse figurant à la fin des présentes conditions générales. Si
      vous le faites, vous devez immédiatement cesser d'utiliser le site Web.
      L'annulation ou la suspension de votre inscription n'affecte pas les
      droits statutaires.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Liens vers d'autres sites Web </h3>
      <br></br>
      9. Ce site Web peut contenir des liens vers d'autres sites. Sauf
      indication expresse, ces sites ne sont pas sous le contrôle de Vivalimda
      Ltd ou de nos sociétés affiliées.
      <br></br>
      10. Nous n'assumons aucune responsabilité quant au contenu de ces sites
      Web et déclinons toute responsabilité pour toute forme de perte ou de
      dommage résultant de leur utilisation.
      <br></br>
      11. L'inclusion d'un lien vers un autre site sur ce site Web n'implique
      aucune approbation des sites eux-mêmes ou de ceux qui les contrôlent.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Disponibilité du site Web et clauses de non-responsabilité{" "}
      </h3>
      <br></br>
      12. Toutes les installations, outils, services ou informations en ligne
      que Vivalimda Ltd met à disposition par le biais du site Web (le Service)
      sont fournis « en l'état » et « selon la disponibilité ». Nous ne donnons
      aucune garantie que le Service sera exempt de défauts et/ou de fautes.
      Dans toute la mesure permise par la loi, nous ne fournissons aucune
      garantie (expresse ou implicite) d'adéquation à un usage particulier,
      d'exactitude des informations, de compatibilité et de qualité
      satisfaisante. Vivalimda Ltd n'a aucune obligation de mettre à jour les
      informations sur le site Web.
      <br></br>
      13. Bien que Vivalimda Ltd fasse des efforts raisonnables pour s'assurer
      que le site Web est sécurisé et exempt d'erreurs, de virus et d'autres
      logiciels malveillants, nous ne donnons aucune garantie à cet égard et
      tous les utilisateurs assument la responsabilité de leur propre sécurité,
      de celle de leurs données personnelles et de leurs ordinateurs.
      <br></br>
      14. Vivalimda Ltd décline toute responsabilité en cas d'interruption ou
      d'indisponibilité du site Web.
      <br></br>
      15. Vivalimda Ltd se réserve le droit de modifier, suspendre ou
      interrompre toute partie (ou l'intégralité) du site Web, y compris, mais
      sans s'y limiter, tous les produits et/ou services disponibles. Les
      présentes conditions générales continueront de s'appliquer à toute version
      modifiée du site Web, sauf indication contraire expresse.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Limitation de responsabilité</h3>
      <br></br>
      16. Rien dans les présentes conditions générales ne permettra: (a) de
      limiter ou d'exclure notre ou votre responsabilité en cas de décès ou de
      blessure corporelle résultant de notre négligence ou de la vôtre, le cas
      échéant; (b) limiter ou exclure notre ou votre responsabilité en cas de
      fraude ou de fausse déclaration frauduleuse ; ou (c) limiter ou exclure
      l'une de nos ou vos responsabilités d'une manière qui n'est pas autorisée
      par la loi applicable.
      <br></br>
      17. Dans la mesure où le site Web et le contenu sont fournis gratuitement,
      nous ne serons pas responsables envers vous de toute perte ou dommage de
      quelque nature que ce soit.
      <br></br>
      18. Nous ne serons pas responsables envers vous en ce qui concerne les
      pertes résultant d'événements indépendants de notre volonté.
      <br></br>
      20. Dans toute la mesure permise par la loi, Vivalimda Ltd n'accepte
      aucune responsabilité pour l'un des éléments suivants:
      <br></br>
      a. toute perte commerciale, telle que la perte de bénéfices, de revenus,
      de revenus, d'économies anticipées, d'affaires, de contrats, de clientèle
      ou d'opportunités commerciales;<br></br>
      b. la perte ou la corruption de données, de bases de données ou de
      logiciels;<br></br>
      c. toute perte ou dommage spécial, indirect ou consécutif.
      <br></br>
      <h3 className="font-semibold text-xl">Limitation de responsabilité</h3>
      <br></br>
      21. Vous ne pouvez transférer aucun de vos droits en vertu des présentes
      conditions générales à une autre personne. Nous pouvons transférer nos
      droits en vertu des présentes conditions générales lorsque nous pensons
      raisonnablement que vos droits ne seront pas affectés.
      <br></br>
      22. Nous pouvons modifier ces conditions générales de temps à autre. Ces
      conditions révisées s'appliqueront au site Web à compter de la date de
      publication. Les utilisateurs doivent vérifier régulièrement les
      conditions générales pour s'assurer qu'ils se familiarisent avec la
      version actuelle à l'époque.
      <br></br>
      23. Les présentes conditions générales, ainsi que la politique de
      confidentialité et la politique en matière de cookies, constituent
      l'intégralité de l'accord entre les parties relatif à son objet et
      remplacent toutes les discussions, arrangements ou accords antérieurs qui
      auraient pu avoir lieu en relation avec les conditions générales.
      <br></br>
      24. La loi de 1999 sur les contrats (droits des tiers) ne s'applique pas
      aux présentes conditions générales et aucun tiers n'aura le droit
      d'appliquer ou de s'appuyer sur une disposition des présentes conditions
      générales.
      <br></br>
      25. Si un tribunal ou une autorité compétente estime qu'une disposition
      des présentes conditions générales (ou une partie d'une disposition) est
      invalide, illégale ou inapplicable, cette disposition ou partie de
      disposition sera, dans la mesure requise, réputée supprimée, et la
      validité et l'applicabilité des autres dispositions des présentes
      conditions générales n'en seront pas affectées.
      <br></br>
      26. Sauf accord contraire, aucun retard, acte ou omission d'une partie
      dans l'exercice d'un droit ou d'un recours ne sera considéré comme une
      renonciation à ce droit ou à tout autre droit ou recours.
      <br></br>
      27. Le présent Accord sera régi et interprété conformément au droit de
      l'Angleterre et du Pays de Galles, et tous les litiges découlant de
      l'Accord (y compris les litiges ou réclamations non contractuels) seront
      soumis à la juridiction exclusive des tribunaux anglais et gallois.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl"> Vivalimda Ltd Détails</h3>
      <br></br>
      28. Vivalimda Ltd est une société immatriculée sous le numéro 14185160
      dont le siège social est situé au 150 Midsummer Boulevard, Milton Keynes,
      MK9 1FD et exploite le site Web www.motickets.co.uk. Vous pouvez contacter
      Vivalimda Ltd par e-mail au help@motickets.co.uk.
    </div>
  );
};

export default AcceptableUsePolicy;
